import axios from 'axios'
import VueCookies from 'vue-cookies'
import { isDemoCompanyName } from '@/utils/demoCompany'
// import { useToast } from 'vue-toastification'

import { apiBaseUrl as baseUrl } from './baseUrl'
// const baseUrl = 'http://localhost:8070'

const getClientTokenHeaders = () => {
  const token = VueCookies.get('client_token')
  return {
    client_token: token
  }
}

// 회사 코드 조회
const companycodeLookup = (companyCode) => {
  return axios.get(`${baseUrl}/company/v1/info/${companyCode}`)
}
// 회사 코드 부여
const companycodeAssign = () => {
  return axios.get(`${baseUrl}/company/v1/create-companycode`)
}
// 회사/관리자 회원가입 V1
// const adminSignup = (adminData) => {
//   return axios.post(`${baseUrl}/company/v1/register`, adminData)
// }
// 회사/관리자 회원가입 V2
const adminSignup = (adminData) => {
  return axios.post(`${baseUrl}/company/v2/register`, adminData)
}
// 임직원 약관동의 정보등록
const adminSignupTerms = (adminTermsData) => {
  return axios.put(`${baseUrl}/company/v1/register/terms`, adminTermsData)
}
// 이메일 인증 코드 전송
const emailCodeSend = (input_email) => {
  return axios.post(`${baseUrl}/company/v1/sendemail/verification-email?email=${input_email}`)
}
// 이메일 인증 코드 확인
const emailCodeCheck = (email, code) => {
  return axios.post(`${baseUrl}/company/v1/verification-email`, { email, code })
}
// 권한 전체 조회
const companyAuthorityLookup = () => {
  // localStorage에서 loginAccount 값을 가져옵니다.
  let loginAccount = localStorage.getItem('loginAccount')
  // loginAccount가 null인 경우 localStorage에서 companyName을 확인합니다.
  if (!loginAccount) {
    const companyName = localStorage.getItem('companyName')
    const adminName = localStorage.getItem('admin_name')
    if (isDemoCompanyName(companyName) && adminName === '홍길동') {
      loginAccount = 'adminDemo'
    }
  }
  // console.log('loginAccount', loginAccount)
  return axios.get(`${baseUrl}/company/v1/authority/${loginAccount}`, {
    headers: getClientTokenHeaders()
  })
}
// 로그인 조회
const loginLookup = (userID, passWord, companyCode) => {
  return axios.post(`${baseUrl}/company/v2/login/admin`, {
    user_id: userID,
    password: passWord,
    company_code: companyCode
  })
}
// 로그인 조회 테스트 (client_token 유효 시간 5분 / refresh_token 유효 시간 10분으로 설정)
// const loginLookup = (userID, passWord, companyCode) => {
//   return axios.post(`${baseUrl}/company/v2/login-test/admin`, {
//     user_id: userID,
//     password: passWord,
//     company_code: companyCode
//   })
// }
// 임직원 임시 비밀번호 변경
const passwordChange = (userID, PastPassword, NewPassWord, companyCode) => {
  return axios.put(`${baseUrl}/company/v1/update-password/employee`, {
    user_id: userID,
    past_password: PastPassword,
    new_password: NewPassWord,
    company_code: companyCode
  })
}
// 임직원 비밀번호 찾기
const passwordFind = (companyCode, userID, Email) => {
  return axios.post(`${baseUrl}/company/v2/findpassword/admin`, {
    company_code: companyCode,
    admin_account: userID,
    company_email: Email
  })
}
// 데모 로그인 API 호출
const demoLogin = () => {
  return axios.post(`${baseUrl}/company/v2/login/admin/demo`)
}
// 로그인 기간 연장(토큰 연장발급)
const loginPeriodExtend = async (clientToken, refreshToken) => {
  // const toast = useToast() // useToast 훅을 여기서 직접 사용합니다
  try {
    const response = await axios.post(
      `${baseUrl}/company/v1/refresh`,
      {},
      {
        headers: {
          client_token: clientToken,
          refresh_token: refreshToken
        }
      }
    )
    if (response.status === 200 && response.data.response.body.items) {
      const newToken = response.data.response.body.items.client_token
      if (newToken) {
        // newToken이 유효한지 검사
        // sessionStorage.setItem('token', newToken)
        // localStorage.setItem('token', newToken)
        VueCookies.set('client_token', newToken)
        // biz_pay 값이 warning일 때 토스트 메시지 추가
        // if (response.data.response.body.items.biz_pay === 'warning') {
        //   toast.warning('갱신해야 할 계약이 있습니다. 여기를 클릭하세요.', {
        //     position: 'top-center',
        //     timeout: false,
        //     closeOnClick: false,
        //     pauseOnFocusLoss: false,
        //     pauseOnHover: true,
        //     draggable: false,
        //     draggablePercent: 0.6,
        //     showCloseButtonOnHover: false,
        //     hideProgressBar: true,
        //     closeButton: 'button',
        //     icon: true,
        //     rtl: false,
        //     onClick: () => {
        //       window.location.href = '/bizpay'
        //     }
        //   })
        // }
        return newToken
      } else {
        throw new Error('새 토큰이 유효하지 않습니다.')
      }
    } else {
      throw new Error('토큰을 새로 발급받지 못했습니다.')
    }
  } catch (error) {
    console.error('로그인 기간 연장 중 오류 발생:', error)
  }
}
// 유저 정보 조회
// axios 인터셉터 요청 설정
axios.interceptors.request.use(
  (config) => {
    // const token = sessionStorage.getItem('client_token')
    // const token = localStorage.getItem('client_token')
    const token = VueCookies.get('client_token')
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

export {
  // adminSignup,
  adminSignup,
  adminSignupTerms,
  emailCodeSend,
  emailCodeCheck,
  companycodeLookup,
  companycodeAssign,
  companyAuthorityLookup,
  loginLookup,
  passwordChange,
  passwordFind,
  demoLogin,
  loginPeriodExtend
}
